<template>
  <div class="clinic" :style="contentStyleObj">
    <div class="topBox">
      <div>
        <Button type="primary" @click="newCase">新建病历</Button>
      </div>
       <p class="tool">
         <!-- <Button type="primary">预览</Button> -->
         <!-- <Button type="primary">打印</Button> -->
       </p>
       <div class="btnBox">
          <Button type="primary" custom="" @click="newCase">重置</Button>
          <Button type="primary" custom="" @click="saveCase">保存</Button>
        </div>
    </div>
    <div class="mainBox">
      <div class="leftBox">
        <div class="basicinfo">
          <ul>
            <li>
              <div>
                <label><span class="redsize">姓　名：</span></label>
                <div>
                  <Input :disabled="isDisabled" v-model="name" placeholder="姓　名" style="width:150px;"/>
                  <ul v-show="nameShow">
                    <li v-for="(n,nIndex) in nameList" :key="nIndex" @click="selName(n)">
                      {{n.name}} {{n.mobile}}
                    </li>
                  </ul>
                </div>
              </div>
              <p>
                <label><span class="redsize">性　　别：</span></label>
                <RadioGroup v-model="sex" >
                  <Radio v-for="(item,index) in sexList" :label="item.value" v-bind:key="index">{{item.label}}</Radio>
                </RadioGroup>
              </p>
              <p>
                <label><span class="redsize">年　　龄：</span></label>
                <Input v-model="age" placeholder="年龄" style="width:100px;"/>
                <Select v-model="ageUnit" style="width:60px">
                  <Option v-for="item in ageUnitList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </p>
            </li>
            <li>
              <p>
                <label><span class="redsize">手机号：</span></label>
                <Input v-model="phone" placeholder="手机号" style="width:150px;" :maxlength="11" :disabled="isDisabled" />
              </p>
              <p>
                <label class="leftPad">身份证号：</label>
                <Input v-model="idNumber" placeholder="身份证号" style="width:150px;"/>
              </p>
              <p>
                <label class="leftPad">患者来源：</label>
                <Select v-model="patientSource" style="width:150px">
                  <Option v-for="item in patientSourceList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </p>
            </li>
            <li class="longWidth">
              <p>
                <label>家庭住址：</label>
                <Input v-model="familyAdress" placeholder="家庭住址" />
              </p>
            </li>
            <li class="longWidth">
              <div>
                <label><span class="redsize">主诉病情：</span></label>
                <div class="label">
                  <Input type="textarea" :autosize="{minRows: 1,maxRows: 5}" v-model="illComplain" placeholder="主诉病情" @on-focus="getPerfomance" @on-blur="closePerformance"/>
                  <ul v-show="illShow" @click.stop="closeIllKey">
                    <div class="illTitle">常用词汇输入<span class="right" @click="closeIllKey"><i class="iconfont icon-guanbi1"></i></span></div>
                    <div class="illMain">
                      <p>常用症状：</p>
                      <ul>
                        <li v-for="(i,iIndex) in Illness" :key="iIndex" @click.prevent.stop="selIllName(i)">
                          {{i.name}}
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
              </div>
            </li>
            <li @click="infoToggle" class="otherLi">
              <p>
                <label>其他信息：</label>
                <span v-show="!isOther">（点击展开）</span>
                <span v-show="isOther">（点击收缩）</span>
              </p>
            </li>
            <div class="other" v-show="isOther">
              <li class="longWidth">
                <p>
                  <label>既往史：</label>
                  <Input type="textarea" :autosize="{minRows: 1,maxRows: 5}" v-model="previousHistory" placeholder="既往史" />
                </p>
              </li>
              <li class="longWidth allergy">
                <div>
                  <label>过敏史：</label>
                  <div>
                    <RadioGroup v-model="isAllergy" @on-change="changeAllergy">
                      <Radio v-for="(item,index) in isAllergyList" :label="item.value" v-bind:key="index">{{item.label}}</Radio>
                    </RadioGroup>
                    <template v-if="isAllergy==1">
                      <div v-for="(allergy,aIndex) in allergyList" v-bind:key="aIndex">
                        <Select v-model="allergy.allerSo" style="width:150px" :transfer="true">
                          <Option v-for="item in allergySources" :value="item.dataCode" :key="item.dataCode">{{ item.dataName }}</Option>
                        </Select>
                        <Select v-model="allergy.level" style="width:150px" :transfer="true">
                          <Option v-for="item in levelList" :value="item.dataCode" :key="item.dataCode">{{ item.dataName }}</Option>
                        </Select>
                        <Select v-model="allergy.symptom" style="width:150px" :transfer="true">
                          <Option v-for="item in symptomList" :value="item.dataCode" :key="item.dataCode">{{ item.dataName }}</Option>
                        </Select>
                        <span>
                          <Icon custom="iconfont icon-jia"  @click="addAllergyInput" />
                          <Icon custom="iconfont icon-jian" @click="plusAllergyInput(aIndex)"/>
                        </span>
                      </div>
                    </template>
                  </div>
                </div>
              </li>
              <li class="longWidth">
                <p>
                  <label>个人史：</label>
                  <Input v-model="personHistory" placeholder="个人史" />
                </p>
              </li>
              <li class="longWidth">
                <p>
                  <label>家族史：</label>
                  <Input v-model="familyHistory" placeholder="家族史" />
                </p>
              </li> 
              <li class="longWidth allergy">
                <div>
                  <label>体格检查：</label>
                  <div>
                    <p>
                      <span>
                        体温<Input v-model="animalHeat" placeholder="体温" style="width:80px;"/>℃
                      </span>
                      <span>
                        体重<Input v-model="weight" placeholder="体重" style="width:80px;"/>Kg
                      </span>
                      <span>
                        心率<Input v-model="heartRate" placeholder="心率" style="width:80px;"/>bpm
                      </span>
                      <span>
                        体脂<Input v-model="bodyFat" placeholder="体脂" style="width:150px;"/>
                      </span>
                      <span>
                        血压<Input v-model="systolicPress" placeholder="收缩压" style="width:80px;"/>/
                      </span>
                      <span>
                        <Input v-model="diastolicPress" placeholder="舒张压" style="width:80px;"/>
                        mmhg
                      </span>
                    </p>
                    <p>
                      <Input type="textarea" :autosize="{minRows: 1,maxRows: 5}" v-model="otherBuild" placeholder="其他体格检查情况" />
                    </p>
                  </div>
                </div>
              </li> 
            </div>
            <li class="longWidth">
              <div>
                <label><span class="redsize">诊断：</span></label>
                <div>
                  <Input type="textarea" :autosize="{minRows: 1,maxRows: 5}" v-model="diagnose" placeholder="诊断" @on-focus="getDiagnos" />
                  <ul v-show="diagnoseShow" @click.stop="closeDiagKey">
                    <div class="illTitle">常用词汇输入<span class="right" @click="closeDiagKey"><i class="iconfont icon-guanbi1"></i></span></div>
                    <div class="illMain">
                      <p>常用症状：</p>
                      <ul>
                        <li v-for="(d,dIndex) in diagnoseList" :key="dIndex" @click.prevent.stop="selDiagName(d)">
                          {{d.name}}
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="assistant">
          <p>(<span class="redsize"></span>标注为" 住院期间必须检查项目 ",未标注的为 "住院期间根据病情选择项目" )</p>
          <div class="itemTop">
            <ul>
              <div>
                <li :class="{'active-name': index == active}" v-for="(item,index) in itemTitle" v-bind:key="index" @click="clickTopItem(index)">{{item.name}}</li>
              </div>
              <li id="search"><Input search @on-search="search" placeholder="搜索" v-model="keyWord" /></li>
            </ul>
          </div>
          <div class="itemsBox">
            <div class="leftItem">
              <ul>
                <Menu theme="light" accordion @on-open-change="itemLeft">
                  <Submenu :name="index" :key="index" v-for="(item,index) in itemList" :title="item.name">
                    <template slot="title">
                      {{item.name|ellipsis(16)}}
                    </template>
                    <div  v-if="item.children">
                      <MenuItem :name="p.id" v-for="(p,index) in item.children" :key="index" @click.native="subleftItem(index,p)">{{p.title}}</MenuItem>
                    </div>
                  </Submenu>
                </Menu>
              </ul>
            </div>
            <div class="itemMain">
              <ul>
                <li>
                  <span>项目名称</span>
                  <span>价格（元）</span>
                </li>
                <div class="itemMainPro">
                  <li>
                    <div v-for="(project,index) in projectItems" v-bind:key="index">
                      <div @click="openProject(project,index)">
                        <p >
                          <span><i v-show="project.price" :class="{'icon-jiahao':!project.isOpen,'icon-jianhao1':project.isOpen}" class="iconfont"></i></span>
                          <span>{{project.name}}</span>
                        </p>
                        <p :class="{'redsize':project.isMust==1,'blank':project.isMust!=1}" >
                          <span>{{project.price}}</span>
                          <span :class="{'noSelButton':!project.isSelect,'selButton':project.isSelect}" @click.stop="selectProject(project)" >选择</span>
                        </p>
                      </div>
                      <div class="subProject" v-show="project.isOpen" v-if="project.openProject.length>0">
                        <p>{{project.projectName}}</p>
                        <p class="proTitle" >
                          <span>容器图片</span>
                          <span>采集容器</span>
                          <span>标本类型</span>
                          <span>总量</span>
                          <span>单位</span>
                          <span>个数</span>
                        </p>
                        <p v-for="(openPro,index) in project.openProject" v-bind:key="index">
                          <span><img :src="openPro.src" :alt="openPro.specimenTypeName" v-viewer></span>
                          <span>{{openPro.samplingColor}}</span>
                          <span>{{openPro.specimenTypeName}}</span>
                          <span>{{openPro.count}}</span>
                          <span>{{openPro.unitName}}</span>
                          <span>{{openPro.samplingNum}}</span>
                        </p>
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <div class="proItemBox">
            <p>所选项目：</p>
            <div>
              <div v-for="(pShow,pIndex) in projectShow" v-bind:key="pIndex">
                <div class="beforePro">
                  <span>{{pShow.name}}</span>
                  <span>{{pShow.price}}</span>
                  <span>
                    <Icon custom="iconfont icon-jian" @click="plusProInput(pIndex,pShow)" />
                  </span>
                </div>
                <div class="subProject">
                  <p class="proTitle" >
                    <span>项目明细</span>
                    <span>采集容器</span>
                    <span>标本类型</span>
                    <span>总量</span>
                  </p>
                  <p v-for="(project,oIndex) in pShow.openProject" v-bind:key="oIndex">
                    <span>{{project.proNameItem}}</span>
                    <span>{{project.samplingColor}}</span>
                    <span>{{project.specimenTypeName}}({{project.count}}{{project.unitName}})</span>
                    <span>{{project.samplingNum}}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uploadBox">
          <div class="blankBox"></div>
          <div>
            <p>
            附件:点击上传影像学凭证：
            </p>
            <p><Button @click="upload">上传</Button></p>
            <div class="imgBox">
              <span v-for="(img,index) in imgSrcList" v-bind:key="index" v-viewer>
                <i class="iconfont icon-close-b" @click="delImg(index)"></i>
                <img :src="img.url" :alt="img.name" >
              </span>
              <Upload
                  multiple
                  ref="upload"
                  type="drag"
                  :action="uploadAction"
                  :before-upload="beforeUpload"
                  :on-success="successUpload"
                  :show-upload-list="false"
                  >
                  <span>
                    <i class="iconfont icon-jia"></i>
                  </span>
              </Upload>
            </div>
          </div>
        </div>
        <div class="feeBox">
          <p>
            <span>其他费用：</span>
            <span><Button @click="addFeeInput">添加费用</Button></span>
          </p>
          <div v-for="(fee,index) in projectFee" v-bind:key="index">
            <span ></span>
            <div>
              <Input v-model="fee.projectName" @on-blur="getProject(fee,index)" placeholder="项目名称" style="width: 300px" />
              ￥
              <Input v-model="fee.projectFee" @on-blur="getProject(fee,index)" number placeholder="费用" style="width: 60px" />
              <span>
                <Icon custom="iconfont icon-jia"  @click="addFeeInput" />
                <Icon custom="iconfont icon-jian" @click="plusFeeInput(index,fee)" />
              </span>
            </div>
          </div>
        </div>
        <div class="dorAdviceBox">
          <p>
            <span>医嘱：</span>
            <span>
              <Input v-model="dorAdvice" type="textarea" :rows="4" placeholder="请输入医嘱" />
            </span>
          </p>
        </div>
        <div class="showProjectInfo">
          <div>
            <p class="sum">
              <span @click="openInfo">展开明细<i class="ivu-icon" :class="{'ivu-icon-ios-arrow-up':isOpenInfo,'ivu-icon-ios-arrow-down':!isOpenInfo}"></i></span>
              <span>已选{{selProject.length+selOtherProject.length}}个项目</span>
              <span>合计金额：￥{{selProPrice}}</span>
            </p>
            <div v-show="isOpenInfo">
              <p>
                <span>项目名称</span>
                <span>项目金额</span>
                <span></span>
              </p>
              <div v-for="(selpro,proindex) in selProject" v-bind:key="'pro'+proindex" >
                <p>
                  <span>{{selpro.name}}</span>
                  <span>{{selpro.price}}</span>
                  <span><Button @click="removePro(selpro,proindex)" :disabled="selpro.state==2">移除</Button></span>
                </p>
                <template v-for="(child,subIndex) in selpro.openProject" >
                  <li v-bind:key="subIndex" v-if="selpro.openProject">
                    <span>{{child.name}}</span><span></span>
                  </li>
                </template>
              </div>
              <div v-for="(selOther,otherIndex) in selOtherProject" v-bind:key="'other'+otherIndex" >
                <p>
                  <span>{{selOther.name}}</span>
                  <span>{{selOther.price}}</span>
                  <span><Button @click="removeOther(selOther,otherIndex)" :disabled="selOther.state==2">移除</Button></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <Button type="primary" custom="" @click="newCase">重置</Button>
          <Button type="primary" custom="" @click="saveCase">保存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import { 
  searchSick,searchInspection,
  inspectionType,inspeByType,
  searchProject,projectByType,
  samplingDetail,depmentlist,
  comProject,patientSource,
  getSymptom,getAllerSo,
  getLevel,isSingleItem,
  projectItems,saveCase,
  getHisDiagnosisById,updCase,
  patientByname,getPerformance,
  getDiagnosiss,getProjectByName
} from "../../../api/clinic";
import {
  patientDetail
} from "../../../api/patient";
import { downloadFile } from "../../../api/common";
import { tips,replaceT,ellipsis } from "../../../tools";
import {baseUrl} from '../../../config' 
export default {
  name: 'ClinicList',
  inject: ['reload'],
  filters:{
    ellipsis
  },
  data () {
    return {
      openShowPro:[],
      diagnoseArr:[],
      diagnoseList:[],//诊断显示集合
      diagnoseShow:false,//诊断显示
      clickNo:0,//主诉点击的数字
      illShow:false,//主诉病情显示
      Illness:[],//主诉病情集合
      nameShow:false,//显示姓名搜索集合
      nameList:[],//姓名集合
      patientList:[],//患者信息集合
      caseId:0,//智能开单保存id
      isOther:false,//其他信息展开
      isDisabled:false,
      typeCode:'',
      uploadAction:baseUrl+'common/common/uploadFile?typeCode=png',//上传地址
      // uploadAction:baseUrl+'common/common/uploadFile?typeCode=consumables',//上传地址
      imgSrcList:[],//本地预览图片集合
      // haveImgSrcList:[],//已上传图片集合
      uploadList:[],//上传集合
      inputIndex:0,
      inputProIndex:0,
      selOtherProject:[],//其他费用项目集合
      projectFee:[],//添加费用集合
      projectPro:[],//添加项目输入框集合
      isOpenInfo:false,//展开明细
      selProPrice:0,//结算金额
      dorAdvice:'',//医嘱
      theme2: 'light',
      phone:'',
      age:'',
      ageUnit:'岁',
      ageUnitList:[
        {
          label:'岁',
          value:'岁'
        },
        {
          label:'个月',
          value:'个月'
        },
        {
          label:'天',
          value:'天'
        }
      ],
      familyAdress:'',//家庭地址
      illComplain:'',//主诉病情
      illComplainArr:[],
      isAllergy:0,//有无过敏史
      isAllergyList:[
        {
          label:'有',
          value:1
        },
        {
          label:'无',
          value:0
        }
      ],
      allergy:'',//过敏史集合
      allergyList:[
      ],
      name:'',
      sex:1,
      sexList:[
        {
          label:'男',
          value:1
        },
        {
          label:'女',
          value:2
        },
        {
          label:'不详',
          value:3
        }
      ],
      idNumber:'',
      patientSource:'',
      patientSourceList:[],
      allerSo:'',//过敏源
      allergySources:[
        {
          dataName:'花粉',
          dataCode:'花粉'
        }
      ],
      level:'',//过敏程度
      levelList:[
        {
          dataName:'轻微',
          dataCode:'轻微'
        }
      ],
      symptom:'',//过敏症状
      symptomList:[
        {
          dataName:'胸闷',
          dataCode:'胸闷'
        }
      ],
      caseAttachmentVoList:[
      ],//上传图片id集合
      menstrualBirthHistory:'',//婚育
      personHistory:'',//个人史
      familyHistory:'',//家族史
      previousHistory:'',//既往史
      animalHeat:'',//体温
      weight:'',//体重
      heartRate:'',//心率
      bodyFat:'',//体脂
      systolicPress:'',//血压收缩压
      diastolicPress:'',//血压舒张压
      otherBuild:'',//其他体格状况
      diagnose:'',//诊断
      //辅助
      isOpen:true,
      keyWord:'',//搜索关键词
      active:0,
      leftActive:0,
      itemTitle:[
        {
          name:'高发疾病',
          pid:1
        },
        {
          name:'科室',
          pid:2
        },
        {
          name:'项目类型',
          pid:3
        },
        {
          name:'常用项目',
          pid:4
        },
        
      ],//
      itemList:[],//左侧选项列表
      projectItems:[
      ],//项目列表
      projectOpen:[],//疾病项目列表展开
      selProject:[],//已选费用和项目
      otherProjects:[],//其他费用项目传参
      projectIds:[],//项目传参集合
      allergiesList:[],
      patientId:0,//患者id
      editId:0,
      hospitalCaseId:0,
      projectShow:[],//页面项目展示集合
      historyId:0,
      contentStyleObj:{
        height:0
      }
    }
  },
  watch:{
    //主诉
    clickNo(){
      switch(this.clickNo){
        case 0:
          this.illShow = false;
          break;
        case 1:
          this.illShow = true;
          break;
        case 2:
          this.illShow = false;
          break;
      }
    },
    getSick(){
      this.keyWord = this.getSick;
      this.searchSick();
    },
    getExpandName(){
      // console.log(this.getExpandName);
      this.getExpandArr();
    },
    name(){
      this.$store.commit('setPatient',this.name); 
      this.$store.commit('setPhone',this.phone); 
      // console.log(this.name);
      
      if(this.name!=''){
        if(this.isDisabled){
          this.nameShow = false;
        }else{
          this.getPatientByName(this.name);
        }
        
      }else{
        this.nameList = [];
      }
    },
    phone(){
      this.$store.commit('setPatient',this.name); 
      this.$store.commit('setPhone',this.phone); 
      // console.log(this.$store.state.patientName,this.$store.state.phone);
    }
  },
  created(){
    window.addEventListener('resize', this.getHeight);
    this.getHeight();
  },
  mounted(){
    // 标准模式时(document.compatMode == 'CSS1Compat')，body = document.documentElement
    var body = (document.compatMode && document.compatMode == 'CSS1Compat') ? document.documentElement : document.body;
    // console.log(body.clientHeight);
    // console.log(body.clientWidth);
    this.patientId = this.$route.query.patientId;
    this.editId = this.$route.query.editId;
    this.hospitalCaseId = this.$route.query.hospitalCaseId;
    this.historyId = this.$route.query.historyId;
    let appId = this.$route.query.appId;
    if(appId>0){
      this.patientId = appId;
      this.getBasicInfo();
    }
    if(this.editId>0){
      this.getHisDiagnosisById(this.editId);
    }
    if(this.hospitalCaseId){
      this.updCase(this.hospitalCaseId);
    }
    if(this.historyId){
      this.updCase(this.historyId);
    }
    if(this.patientId>0){
      this.getBasicInfo();
    }
    this.searchSick();
    this.getPatiSour();
  },
  computed:{
    ...mapGetters(['getSick','getExpandName'])
  },
  methods:{
    getHeight(){
      this.contentSyleObj.height=window.innerHeight-220+'px';
    },
    getFeeHeight(){

    },
    //获取诊断数据
    getDiagnos(){
      getDiagnosiss().then(res=>{
        // console.log(res);
        this.diagnoseList = res;
        this.diagnoseShow = true;
      });
    },
    //选择诊断关键词
    selDiagName(data){
      // console.log(data);
      // console.log(this.clickNo);
      let arr = [];
      let index = this.diagnoseArr.findIndex(target=>target==data.name);

      if(index==-1){
        this.diagnoseArr.push(data.name);
        this.diagnose = this.diagnoseArr.join(',');
      }
      this.diagnoseShow = true;
    },
    //关闭诊断关键词框
    closeDiagKey(){
      this.diagnoseShow = false;
    },
    //选择主诉名称
    selIllName(data){
      // console.log(data);
      this.clickNo = 1;
      // console.log(this.clickNo);
      let arr = [];
      let index = this.illComplainArr.findIndex(target=>target==data.name);
      if(index==-1){
        this.illComplainArr.push(data.name);
        this.illComplain = this.illComplainArr.join(',');
      }else{
        
      }
    },
    //关闭
    closeIllKey(){
      // console.log(2222);
      this.clickNo = 2;
      // console.log(this.clickNo);
      
      // this.illShow = false;
    },
    //获取主诉病情集合
    getPerfomance(){
      getPerformance({}).then(res=>{
        // console.log(res);
        this.Illness = res;
        this.clickNo = 1;
        // console.log(this.clickNo);
      });
    },
    //关闭主诉集合
    closePerformance(){
      // this.clickNo = 0;
      // console.log(this.clickNo);
    },
    //选择名字加载基本信息
    selName(data){
      // console.log(data);
      this.nameList = [];
      this.phone = data.mobile;
      this.name = data.name;
      this.sex = data.sex;
      this.age = data.age;
      this.ageUnit = data.ageUnit;
      this.nameShow = false;
    },
    //名字查询患者信息
    getPatientByName(name){
      patientByname({
        name:name
      }).then(res=>{
        // console.log(res);
        
        if(res.length>0){
          this.nameList = res;
          this.nameShow = true;
        }
        // this.patientList = res;
        // console.log(this.nameList);
      });
    },
    getExpandArr(){
      let _this = this;
      
      // console.log(this.getExpandName);
      // console.log(this.projectItems);
      for(let i=0;i<_this.getExpandName.length;i++){
        let project = _this.getExpandName[i];
        let index = _this.projectItems.findIndex(target=>target.id==project.id);
        let psIndex = _this.projectShow.findIndex(target=>target.id==project.id);
        let spIndex = _this.selProject.findIndex(target=>target.id==project.id);
          // console.log(index);
          // console.log(psIndex);
          // console.log(spIndex);
        //项目选中时
        if(project.isSel){
          //项目按钮显示存在时
          if(index!=-1){
            _this.projectItems[index].isSelect = project.isSel;
          }
          //项目列表
          //集合不存在值，则加入
          if(psIndex==-1){
            let pObj = {
              name:'',
              price:'',
              id:'',
              openProject:[]
            };
            let selProArr = [];
            selProArr = _this.projectShow;
            if(project.hospitalProjectName){
              pObj.name = project.hospitalProjectName;
            }else{
              pObj.name = project.name;
            }
            pObj.id = project.id;
            pObj.price = project.price;
            samplingDetail({
              orderIds:[project.id]
            }).then(res =>{
              // console.log(res);
              if(res.length>0){
                _this.$forceUpdate();
                _this.$set(pObj,'openProject',res);
                // console.log(_this.projectShow);
              }
            });
            selProArr.push(pObj);
            _this.projectShow = selProArr;
            // console.log(_this.projectShow);
          }
          //项目费用
          if(spIndex==-1){
            let obj = {
              name:'',
              price:'',
              id:'',
              openProject:[]
            };
            let selArr = [];
            selArr = _this.selProject;
            if(project.projectName){
              obj.name = project.projectName;
            }else{
              obj.name = project.name;
            }
            obj.id = project.id;
            obj.price = project.price;
            //查询是否是组套
            selArr.push(obj);
            _this.selProject = selArr;
            _this.getProjectItems(project.id);
            // console.log(_this.selProject);
          }
        }
        //未选中时
        else{
          if(index!=-1){
            _this.projectItems[index].isSelect = project.isSel;
          }
          if(psIndex!=-1){
            _this.projectShow.splice(psIndex,1);
          }
          if(spIndex!=-1){
            _this.selProject.splice(spIndex,1);
          }
          _this.getSum();
        }
      }
    },
    //获取患者基本信息
    getBasicInfo(){
      let _this = this;
      if(_this.patientId){
        _this.isDisabled = true;
        patientDetail({
          id:_this.patientId
        }).then(res=>{
          // console.log(res);
          _this.name = res.name;
          _this.sex = res.sex;
          _this.age = res.age;
          _this.ageUnit = res.ageUnit;
          _this.phone = res.mobile
        });
      }
    },
    //新建病历，刷新本页
    newCase(){
      this.$router.push({path:'cliniclist'});
      this.reload();
    },
    //获得患者来源
    getPatiSour(){
      let _this = this;
      patientSource({
      }).then(res => {
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj={
            label:'',
            value:''
          }
          obj.label = item.dataName;
          obj.value = item.dataCode;
          arr.push(obj);
          _this.patientSourceList = arr;
          
        });
        _this.patientSource = _this.patientSourceList[0].value;
      });
    },
    /**选择项目 */
    //点击标题切换样式
    clickTopItem(index){
      let _this = this;
      _this.active = index;
      switch(index){
        case 0:
          _this.searchSick();
          break;
        case 1:
          _this.depmentlist();
          break;
        case 2:
          _this.searchPItem();
          break;
        case 3:
          _this.comProject();
          break;
      }
    },
    updateActiveName(){
      // console.log(1231321);
    },
    //搜索框绑定事件
    search(){
      let _this = this;
      // console.log(_this.keyword);
      switch(_this.active){
        case 0:
          _this.searchSick();
          break;
        case 1:
          _this.searchSick();
          break;
        case 2:
          _this.searchProject();
          break;
      }
    },
    //搜索高发疾病
    searchSick(){
      let _this = this;
      searchSick({
        name:_this.keyWord
      }).then(res => {
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj={
            id:'',
            name:'',
            children:[],
            isSelect:false
          }
          obj.id = item.id;
          obj.name = item.title;
          arr.push(obj);
          _this.itemList = arr;
          
        });
        // console.log(arr);
          _this.projectBysick(_this.itemList[0].id);
      });
    },
    //搜索项目
    searchProject(){
      let _this = this;
      // console.log(_this.keyWord);
      
      searchProject({
        name:_this.keyWord
      }).then(res => {
        // console.log(res)
        let arr = [];
        res.forEach(item => {
          let obj = {
            id: item.id,
            name: item.projectName,
            price: item.price,
            isOpen:false,
            openProject:[],
            isSelect:false,
            state:''
          };
          arr.push(obj);
        });
        _this.projectItems = arr;
        for(let i=0;i<_this.selProject.length;i++){
          let selIndex = _this.projectItems.findIndex(target=>target.id==_this.selProject[i].id);
          if(selIndex!=-1){
            _this.projectItems[selIndex].isSelect = true;
            _this.projectItems[selIndex].state = _this.selProject[i].state;
          }
        }
        // _this.getExpandArr();
      })
    },
    //搜索推广项目
    getProjectByName(expandName){
      let _this = this;
      getProjectByName({
        name:expandName
      }).then(res=>{
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj={
            id:'',
            name:'',
            children:[],
            isSelect:false
          }
          obj.id = item.id;
          obj.name = item.title;
          arr.push(obj);
          _this.itemList = arr;
        });
        // console.log(arr);
          _this.projectBysick(_this.itemList[0].id);
      });
    },
    //点击左侧项目类型查询,绑定事件
    itemLeft(index){
      let _this = this;
      // console.log(this.itemList);
      // console.log(index);
      // console.log(_this.active);
      
      //如果选中，即有值，进行判断
      if(index[0]){
        // console.log(_this.itemList[index].children)
        // if(_this.itemList[index].children.length<=0){
          switch(_this.active){
            case 0:
              let sickId = _this.itemList[index].id;
              _this.projectBysick(sickId);
              break;
            case 1:
              let depId = _this.itemList[index].id;
              _this.projectBysick(depId);
              break;
            case 2:
              // let id = _this.itemList[index].id;
              // _this.projectByType(id);
              _this.projectByType(_this.itemList[0].id);
              break;
          // }
        }
      }else{
        
      }
    },
    //子集
    subleftItem(index,item){
      // console.log(index,item);
      // console.log(item.id);
      
      let _this = this;
       switch(_this.active){
        case 0:
          let sickId = item.id;
          _this.projectBysick(sickId);
          break;
        case 1:
          let depId = item.id;
          _this.projectBysick(depId);
          break;
        case 2:
          let id = item.id;
          _this.projectByType(id);
          break;
      }
    },
    //点击疾病查询项目
    projectBysick(id){
      let _this = this;
      searchInspection({
        id:id
      }).then(res =>{
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let array = [];
          let obj = {
            id: item.id,
            isMust: item.isMust,
            name: item.name,
            price: item.price,
            projectName:item.projectName,
            isOpen:false,
            openProject:array,
            isSelect:false,
            state:''
          };
          arr.push(obj);
        });
        // console.log(arr);
        _this.projectItems = arr;
        for(let i=0;i<_this.selProject.length;i++){
          let selIndex = _this.projectItems.findIndex(target=>target.id==_this.selProject[i].id);
          if(selIndex!=-1){
            _this.projectItems[selIndex].isSelect = true;
            _this.projectItems[selIndex].state = _this.selProject[i].state;
          }
        }
        // _this.getExpandArr();
        // console.log(_this.projectItems);
      });
    },
    //点击项目类型查询项目
    projectByType(id){
      // console.log(id);
      
      let _this = this;
      projectByType({
        id:id
      }).then(res => {
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj = {
            id: item.id,
            name: item.projectName,
            price: item.price,
            isOpen:false,
            openProject:[],
            isSelect:false,
            state:''
          };
          arr.push(obj);
        });
        _this.projectItems = arr;
        // console.log(this.projectItems);
        for(let i=0;i<_this.selProject.length;i++){
          let selIndex = _this.projectItems.findIndex(target=>target.id==_this.selProject[i].id);
          if(selIndex!=-1){
            _this.projectItems[selIndex].isSelect = true;
            _this.projectItems[selIndex].state = _this.selProject[i].state;
          }
        }
      });
    },
    //查找所有项目名称
    searchPItem(){
      let _this = this;
      inspectionType({}).then(res => {
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj={
            name:'',
            id: 0,
            children:[]
          }
          obj.name = item.name;
          obj.id = item.id;
          arr.push(obj);
          _this.itemList = arr;
        });
        // console.log(_this.itemList);
        
        _this.projectByType(_this.itemList[0].id);
      });
    },
    //科室下的疾病
    depmentlist(){
      let _this = this;
      depmentlist({}).then(res => {
        // console.log(res);
        // this.itemList = res;
        let arr = [];
        res.forEach(item => {
          let obj={
            name:'',
            children:[]
          }
          obj.name = item.name;
          obj.children = item.hisClinicalPathwayVos;
          arr.push(obj);
          _this.itemList = arr;
        });
        let id = _this.itemList[0]["children"][0].id;
        // console.log(_this.itemList[0]["children"][0].id);
        _this.projectBysick(id);
        // console.log(arr);
      })
    },
    //常用项目查询
    comProject(){
      let _this = this;
      comProject().then(res => {
        // console.log(res);
        let arr = [];
        res.forEach(item => {
          let obj = {
            id: item.hospitalProjectId,
            name: item.projectName,
            price: item.price,
            isOpen:false,
            openProject:[],
            isSelect:false,
            state:''
          };
          arr.push(obj);
        });
        _this.projectItems = arr;
        // console.log(this.projectItems);
        for(let i=0;i<_this.selProject.length;i++){
          let selIndex = _this.projectItems.findIndex(target=>target.id==_this.selProject[i].id);
          if(selIndex!=-1){
            _this.projectItems[selIndex].isSelect = true;
            _this.projectItems[selIndex].state = _this.selProject[i].state;
          }
        }
        _this.itemList = [];
      });
    },
    //展开
    openProject(project,ind){
      let _this = this;
      // console.log(project);
      if(!project.isOpen){
        _this.$set(_this.projectItems[ind],'isOpen',true);
        samplingDetail({
          orderIds:[project.id]
        }).then(res =>{
          // console.log(res);
          let arr = res;
          for(let i=0;i<res.length;i++){
            let imgSrc = _this.getProjectImg(res[i].consumablesFileTypeId,res[i].specimenTypeName)
            _this.$forceUpdate();
            _this.$set(arr[i],'src',imgSrc);
          }
          // console.log(arr);
          if(res.length>0){
            _this.$forceUpdate();
            _this.$set(_this.projectItems[ind],'openProject',arr);
          }
          // console.log(_this.projectItems)
        });
      }else{
        _this.$set(_this.projectItems[ind],'isOpen',false);
      }
      // console.log(project.isOpen);
    },
    //取试管图片
    getProjectImg(id,fileName){
      // console.log(id,fileName);
      let _this = this;
      let url = baseUrl+'common/common/downLoadFile?attachId='+id+'&fileName='+fileName+'&type=0';
      return url;
    },
    selectProject(project){
      let _this = this;
      
      // console.log(project.isSelect);
      console.log(project);
      //项目显示集合
      let pObj = {
        name:'',
        price:'',
        id:'',
        openProject:[]
      };
      let obj = {
        name:'',
        price:'',
        id:'',
        openProject:[]
      }
      let selArr = [];
      selArr = _this.selProject;
      let selProArr = [];
      selProArr = _this.projectShow;
      if(project.id){
        //点击时为true时，改为false；即选中的时候变非选中
        if(project.state==2){
          tips(_this,'已收费项目不能取消！','info');
        }else{
          // console.log(project.projectName);
          // console.log(project.name);
          if(!project.isSelect){
            project.isSelect = true;
            if(project.projectName){
              obj.name = project.projectName;
              pObj.name = project.projectName;
            }else{
              obj.name = project.name;
              pObj.name = project.name;
            }
            obj.id = project.id;
            obj.price = project.price;
            selArr.push(obj);
            _this.selProject = selArr;
            
            pObj.id = project.id;
            pObj.price = project.price;
            selProArr.push(pObj);
            _this.projectShow = selProArr;
            
            let pIndex = _this.projectShow.findIndex(target=>target.id==project.id);
            // console.log(pIndex);
            if(pIndex!=-1){
              samplingDetail({
                orderIds:[project.id]
              }).then(res =>{
                // console.log(res);
                if(res.length>0){
                  let sampItems = res;
                  for(let i=0;i<sampItems.length;i++){
                    // console.log(sampItems[i].list);
                    let subArr = []
                    for(let j=0;j<sampItems[i].list.length;j++){
                      subArr.push(sampItems[i].list[j].projectName);
                    }
                    this.$forceUpdate();
                    this.$set(sampItems[i],'proNameItem',subArr.join(','));
                  }
                  _this.$forceUpdate();
                  _this.$set(_this.projectShow[pIndex],'openProject',sampItems);
                  // console.log(_this.projectShow);
                }
              });
            }
            //查询是否是组套
            _this.getProjectItems(project.id);
            //选中推广项目
            let insIndex = _this.getExpandName.findIndex(target=>target.id==project.id);
            // console.log(_this.getExpandName);
            
            if(insIndex!=-1){
              _this.getExpandName[insIndex].isSel = true;
            }
          }else{
            project.isSelect = false;
            let selIndex = _this.selProject.findIndex(target=>target.id==project.id);
            if(selIndex!=-1){
              _this.selProject.splice(selIndex,1);
              _this.projectShow.splice(selIndex,1);
            }
            let pIndex = _this.projectItems.findIndex(target=>target.id==project.id);
            if(pIndex!=-1){
              _this.getExpandName[pIndex].isSel = false;
            }
            //计算总金额
          _this.getSum();
          }
          // console.log(selProArr);
          console.log(_this.projectShow);
        }
      }else{
        tips(_this, "该医院暂未添加该项目！", "info");
      }
    },
    //项目集合
    getProjectItems(orderIds){
      let _this = this;
      projectItems({
        orderIds:[orderIds]
      }).then(res =>{
        let data = res[0];
        let selArr = [];
        selArr = _this.selProject;
        let selIndex = _this.selProject.findIndex(target=>target.id==orderIds);
        _this.$forceUpdate();
        _this.$set(selArr[selIndex],'openProject',data.saleProjectVos);
        _this.selProject = selArr;
        //计算总金额
        _this.getSum();
      });
    },
    //展开明细
    openInfo(){
      let _this = this;
      console.log(this.isOpenInfo);
      // this.isOpenInfo = !this.isOpenInfo;
      if(_this.isOpenInfo){
        _this.isOpenInfo = false;
      }else{
        if(_this.selProject.length>0||_this.selOtherProject.length>0){
          _this.isOpenInfo = true;
        }else{
          tips(_this, "未选择项目，请选择！", "info");
        }
      }
    },
    /**项目页面展示 */
    //减去项目框
    plusProInput(index,data){
      // console.log(data)
      
      if(data.state==2){
        tips(this,'已收费项目不能取消','info');
      }else{
        this.projectShow.splice(index,1);
        //选项目按钮不选
        let pIndex = this.projectItems.findIndex(target=>target.id==data.id);
        // console.log(pIndex);
        if(pIndex!=-1){
          this.$forceUpdate();
          this.$set(this.projectItems[pIndex],'isSelect',false);
        }
        //费用集合移除
        let selIndex = this.selProject.findIndex(target=>target.id==data.id);
        // console.log(selIndex);
        if(selIndex!=-1){
          this.selProject.splice(selIndex,1);
        }
        //推广项目取消
        let index = this.getExpandName.findIndex(target=>target.id==data.id);
        // console.log(index);
        if(index!=-1){
          this.getExpandName[index].isSel = false;
        }
      }
      // console.log(this.projectItems);
      //计算总金额
      this.getSum();
      // console.log(this.projectShow);

    },
    /**其他费用 */
    //新增费用框
    addFeeInput(){
      let obj = {
        projectName:'',
        projectFee:'',
        feeId:this.inputIndex
      };
      this.projectFee.push(obj);
      this.inputIndex++;
      // console.log(this.projectFee);
      // console.log(this.inputIndex);
    },
    //减去费用框
    plusFeeInput(index,data){
      // console.log(data)
      if(data.state==2){
        tips(this,'已收费用不能取消','info');
      }else{
        this.projectFee.splice(index,1);

        for(let i=0;i<this.projectFee.length;i++){
          let selIndex = this.selOtherProject.findIndex(target=>target.feeId==index);
          // console.log(selIndex);
          if(selIndex!=-1){
            this.selOtherProject.splice(selIndex,1);
          }
        }
      }
    },
    //得到项目和费用
    getProject(data,index){
      let _this = this;
      // console.log(data)
      let regFee =/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/;
      // console.log(regFee.test(data.projectFee))

      //两输入框都存在时，增加到项目集合
      if(data.projectName&&data.projectFee){
        if(data.projectFee){
          if(!regFee.test(data.projectFee)){
            tips(_this,"请填写正确格式的费用！","warning");
          }else{
            let obj = {
              name:data.projectName,
              price:data.projectFee,
              feeId:data.feeId
            }
            let selindex = _this.selOtherProject.findIndex(target=>target.feeId==index);
            if(selindex!=-1){
              _this.selOtherProject[selindex] = obj;
            }else{
              _this.selOtherProject.push(obj) ;
              // console.log(_this.selOtherProject);
              // console.log(_this.isOpenInfo);
              
            }
            //计算总金额
            _this.getSum();
          }
        }
      }
      else{
        // console.log(222)
      }
      // console.log(_this.selOtherProject);
    },
    //移除项目
    removePro(data,index){
      let _this = this;
      // console.log(data)
      // console.log(index)
      //state为2时，不可移除
      if(data.state==2){
        tips(_this,'')
      }else{
        //移除项目
        let selIndex = _this.selProject.findIndex(target=>target.id==data.id);
        if(selIndex!=-1){
          _this.selProject.splice(selIndex,1);
        }
        //去掉选中
        let selectIndex = _this.projectItems.findIndex(target=>target.id==data.id);
        if(selectIndex!=-1){
          _this.projectItems[selectIndex].isSelect = false;
        }
        //推广项目取消
        let index = this.getExpandName.findIndex(target=>target.id==data.id);
        // console.log(index);
        if(index!=-1){
          this.getExpandName[index].isSel = false;
        }
      }
      
      //计算总金额
      _this.getSum();
    },
    //移除其他项目
    removeOther(data,index){
      let _this = this;
      // console.log(data)
      //移除项目
      _this.selOtherProject.splice(index,1);
      //去除input框
      // console.log(_this.projectFee);
      let selectIndex = _this.projectFee.findIndex(target=>target.feeId==data.feeId);
      // console.log(selectIndex);
      if(selectIndex!=-1){
        _this.projectFee.splice(selectIndex,1);
      }
      _this.getSum();
    },
    //计算总金额
    getSum(){
      let _this = this;
      //计算总金额
      let projectFee = 0;
      let otherFee = 0;
      for(let i=0;i<_this.selProject.length;i++){
        projectFee += Number(_this.selProject[i].price)*1000;
      }
      for(let j=0;j<_this.selOtherProject.length;j++){
        otherFee += Number(_this.selOtherProject[j].price*1000);
      }
      _this.selProPrice = (projectFee + otherFee)/1000;
    },
    /**上传文件 */
    //获得上传
    getAction(){
      // this.typeCode = 'his';
      // this.typeCode = 'consumables';
      // this.uploadAction = this.uploadAction+this.typeCode;
      console.log(this.uploadAction);
    },
    //上传文件
    beforeUpload(files){
      let _this = this;
      // console.log(files);
      this.getAction();
     
      let reader = new FileReader()
      reader.readAsDataURL(files)

      reader.onloadend = function (e) {
          files.url = reader.result
          _this.imgSrcList.push(files)
      }
      // console.log(_this.imgSrcList)
      this.uploadList.push(files);
      // console.log(this.uploadList);
      
      return false;
    },
    successUpload(response,file,fileList){
      // console.log(response);
      if(response.code===0){
        tips(this, "上传成功", "success");
        let fileData = response.data;
        let arr = [];
        arr = this.caseAttachmentVoList;
        let obj = {
          attachmentId: 0
        };
        obj.attachmentId = fileData[0].id;
        arr.push(obj);
        // console.log(arr)
        this.caseAttachmentVoList = arr;
      }
      // console.log(this.caseAttachmentVoList);
    },
    //点击上传
    upload(){
      if (this.uploadList.length === 0) {
        this.$Message.error('未选择上传文件')
        return false;
      }
      for (let i = 0; i < this.uploadList.length; i++) {
        let item = this.uploadList[i];
        this.$refs.upload.post(item);
      }
      // console.log(this.uploadList);
      
    },
    /**过敏 */
    //选择有还是无
    changeAllergy(sel){
      // console.log(sel)
      switch(sel){
        case 0:
          break;
        case 1:
          this.getAllergy();
          break;
      }
      // console.log(this.isAllergy);
    },
    //过敏下拉框
    getAllergy(){
      let _this = this;
      let obj = {
        allerSo:'1',
        level:'1',
        symptom:'1'
      };
      _this.allergyList.push(obj);
      getSymptom({}).then(res =>{
        // console.log(res);
        _this.allergySources = res;
      });
      getAllerSo({}).then(res =>{
        // console.log(res);
        _this.levelList = res;
      });
      getLevel({}).then(res =>{
        // console.log(res);
        _this.symptomList = res;
      });
      
    },
    //新增过敏输入框
    addAllergyInput(){
      let _this = this;
      let obj = {
        allerSo:'',
        level:'',
        symptom:''
      };
      _this.allergyList.push(obj);
      // console.log(_this.allergyList);
    },
    //减去过敏输入框
    plusAllergyInput(index){
      let _this = this;
      _this.allergyList.splice(index,1);
      // console.log(this.allergyList.length);
      //长度为0时，状态变成无
      if(!_this.allergyList.length>0){
        _this.isAllergy = 0;
      }
      // console.log(_this.allergyList);
    },
    //根据待诊id查询别表
    getHisDiagnosisById(id){
      let _this = this;
      getHisDiagnosisById(
        {
          id:id
        }
      ).then(res => {
        console.log(res);
        _this.name = res.name;
        _this.sex = res.sex;
        _this.age = res.age;
        _this.ageUnit = res.ageUnit;
        _this.phone = res.mobile;
        _this.patientSource = res.sourceType;
        _this.isDisabled = true;
      });
    },
    //修改病历信息
    updCase(id){
      let _this = this;
      updCase({
        id:id
      }).then(res =>{
        // console.log(res);
        _this.isDisabled = true;
        _this.name = res.name;
        _this.sex = res.sex;
        _this.age = res.age;
        _this.ageUnit = res.ageUnit;
        _this.phone = res.mobile
        _this.familyAdress = res.address;
        _this.isAllergy = res.allergieFlag;
        _this.diastolicPress = res.bloodPressureRelaxation;
        _this.systolicPress = res.bloodPressureShrink;
        _this.bodyFat =  res.bodyFat;
        _this.animalHeat = res.bodyTemperature;
        _this.weight = res.bodyWeight;
        // _this.caseAttachmentVoList = res.caseAttachmentVoList;
        _this.diagnose = res.diagnosis; 
        _this.diagnosediagnosis = res.diagnosis;
        _this.familyHistory = res.familyHistory;
        _this.heartRate = res.heartRate;
        _this.idNumber = res.idNumber;
        _this.dorAdvice = res.medicalOrder;
        _this.menstrualBirthHistory = res.menstrualBirthHistory;
        _this.otherBuild = res.otherPhysicalExamination;
        // _this.otherProjects = res.otherProjects;
        _this.previousHistory = res.pastHistory;
        _this.illComplain = res.performance;
        _this.personHistory = res.personalHistory;

        _this.$store.commit('setPatient', res.name); 
        _this.$store.commit('setPhone',res.phone); 
        // console.log(res.otherProjects);
        // console.log(res.projectIds);
        // 已上传图片
        // console.log(res.caseAttachmentVoList);
        if(res.caseAttachmentVoList){
          // let haveImgArr = [];
          let caseAttach = [];
          for(let i1=0;i1<res.caseAttachmentVoList.length;i1++){
            let caseObj = {
              attachmentId: 0
            };
            caseObj.attachmentId = res.caseAttachmentVoList[i1].attachmentId;
            caseAttach.push(caseObj);
            let imgSrc = _this.getProjectImg(res.caseAttachmentVoList[i1].attachmentId);
            let imgObj = {
              url:imgSrc
            };
            _this.imgSrcList.push(imgObj);
          } 
          // console.log(_this.imgSrcList);
          _this.caseAttachmentVoList = caseAttach;
          // console.log(_this.caseAttachmentVoList);
          
          // console.log(haveImgArr);
        }
        
        //项目id集合
        if(res.projectIds){
          let selPro = [];
          let selProArr = [];
          for(let i=0;i<res.projectIds.length;i++){
            let obj ={
              id:0,
              name:'',
              price:'',
              state:0
            }
            obj.id = res.projectIds[i].projectId;
            obj.name = res.projectIds[i].projectName;
            obj.price = res.projectIds[i].price;
            obj.state = res.projectIds[i].state;
            selPro.push(obj);

            let pObj = {
              name:'',
              price:'',
              id:'',
              state:''
            };
            pObj.id = res.projectIds[i].projectId;
            pObj.name = res.projectIds[i].projectName;
            pObj.price = res.projectIds[i].price;
            pObj.state = res.projectIds[i].state;
            selProArr.push(pObj);
            console.log(selProArr);
          }
          _this.selProject = selPro;
          // console.log(_this.selProject);
          
          _this.projectShow = selProArr;
        }
        
        //其他费用项目集合
        if(res.otherProjects){
          let selOther = [];
          let projectFeeArr = [];
          for(let j=0;j<res.otherProjects.length;j++){
            let obj = {
              id:0,
              name: '',
              price: 0,
              state:0
            };
            obj.name = res.otherProjects[j].itemsName;
            obj.price = res.otherProjects[j].price;
            obj.state = res.otherProjects[j].state;
            obj.id = res.otherProjects[j].id;
            selOther.push(obj);

            //其他费用输入框
            
            let feeObj = {
              projectName:'',
              projectFee:'',
              feeId:_this.inputIndex
            };
            
            feeObj.projectName = res.otherProjects[j].itemsName;
            feeObj.projectFee = res.otherProjects[j].price;
            feeObj.state = res.otherProjects[j].state;
            // feeObj.feeId = res.otherProjects[j].id;
            projectFeeArr.push(feeObj);
            _this.inputIndex++;
          }
          _this.selOtherProject = selOther;
          _this.projectFee = projectFeeArr;
          console.log(projectFeeArr);
        }
        //过敏症状
        if(res.allergiesList){
          _this.getAllergy();
          let allers = [];
          // console.log(res.allergiesList);
          for(let k=0;k<res.allergiesList.length;k++){
            let obj = {
              allerSo:'',
              level:'',
              symptom:''
            };
            allers.push(obj);
            // res.allergiesList
            allers[k].allerSo = res.allergiesList[k].sourceType;
            allers[k].level = ''+res.allergiesList[k].degree;
            allers[k].symptom = res.allergiesList[k].behaviorType;
            // allers.push(obj);
          }
          _this.allergyList = allers;
          // console.log(allers);
        }
        _this.getSum();
      })
    },
   
    //保存病历
    saveCase(){
      let _this = this;
      // console.log(_this.selProject)
      // console.log(_this.selOtherProject)
      let selPro = [];
      let selOther = [];
      //项目id集合
      console.log(_this.selProject);
      for(let i=0;i<_this.selProject.length;i++){
        if(_this.selProject[i].state!=2){
          let obj ={
            projectId:0
          }
          obj.projectId = _this.selProject[i].id;
          selPro.push(obj);
        }
      }
      _this.projectIds = selPro;
      //其他费用项目集合
      // console.log(_this.projectIds);
      console.log(_this.selOtherProject);
      for(let j=0;j<_this.selOtherProject.length;j++){
        if(_this.selOtherProject[j].state!=2){
          let obj = {
            itemsName: '',
            price: 0
          };
          obj.itemsName = _this.selOtherProject[j].name;
          obj.price = _this.selOtherProject[j].price;
          selOther.push(obj);
        }
      }
      _this.otherProjects = selOther;
      // console.log(_this.otherProjects);
      let allers = [];
      console.log(_this.allergyList);
      for(let k=0;k<_this.allergyList.length;k++){
        let obj = {
          sourceType:'',
          degree:0,
          behaviorType:''
        };
        allers.push(obj);
        allers[k].sourceType = _this.allergyList[k].allerSo;
        allers[k].degree = _this.allergyList[k].level;
        allers[k].behaviorType = _this.allergyList[k].symptom;
        // allers.push(obj);
        
      }
      _this.allergiesList = allers;
      console.log(_this.allergyList);
      let data = {
        address: _this.familyAdress,
        age: Number(_this.age),
        ageUnit: _this.ageUnit,
        allergieFlag: _this.isAllergy,
        allergiesList: _this.allergiesList,
        bloodPressureRelaxation: Number(_this.diastolicPress),
        bloodPressureShrink: Number(_this.systolicPress),
        bodyFat: Number(_this.bodyFat),
        bodyTemperature: Number(_this.animalHeat),
        bodyWeight: Number(_this.weight),
        caseAttachmentVoList:_this.caseAttachmentVoList,
        diagnosis: _this.diagnose,
        familyHistory: _this.familyHistory,
        heartRate: Number(_this.heartRate),
        idNumber: _this.idNumber,
        medicalOrder: _this.dorAdvice,
        menstrualBirthHistory: _this.menstrualBirthHistory,
        mobile: _this.phone,
        name: _this.name,
        otherPhysicalExamination:_this.otherBuild,
        otherProjects:_this.otherProjects,
        pastHistory: _this.previousHistory,
        performance: _this.illComplain,
        personalHistory: _this.personHistory,
        projectIds:_this.projectIds,
        sex: _this.sex,
        sourceType: _this.patientSource,
        id:_this.hospitalCaseId
      };
      console.log(data);
      saveCase(
        data
      ).then(res =>{
        console.log(res);
        tips(_this, '开单成功', "success");
        // this.reload();
        let menus = _this.$store.state.menus;
          let idx = menus.findIndex(item=>item.url=='/waitcharge');
          console.log(menus)
          console.log(idx);
          if(idx!=-1){
            console.log(menus[idx].id);
            _this.$store.commit('setCheckMenu',menus[idx].id);
            _this.$store.commit('setTags',menus[idx].id);
            _this.$router.push({path:'/waitcharge',query:{caseId:res}});
          }
      });
    },
    infoToggle(){
      this.isOther = !this.isOther;
    },
    //删除图片
    delImg(index){
      console.log(index);
      this.imgSrcList.splice(index,1);
      this.uploadList.splice(index,1);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.leftPad{
  padding-left:10px;
}
.clinic{
  /* overflow: hidden; */
  background-color: #fff;
  /* padding-bottom: 100px; */
}
.clinic>.top{}
.clinic>
.topBox{
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* padding: 10px 0; */
  background-color: #fff;
}
.clinic>.topBox>div{
  padding: 10px 0;
}
.mainBox{
  /* overflow: scroll; */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}
.leftBox{
  width: 100%;
  padding: 10px 0 10px 10px;
}
.basicinfo{
  width: 100%;
}
.basicinfo>ul>li{
  display: flex;
  line-height: 40px;
}
.basicinfo>ul>li.otherLi{
  cursor: pointer;
}
.basicinfo>ul>li.otherLi>p>label{
  padding-left: 10px;
}
.basicinfo>ul>li>p>span{
  color: #2778E7;
}
.basicinfo>ul>li>div{
  display: flex;
  width: 33%;
}
.basicinfo>ul>li>div>label{
  min-width: 106px;
  text-align: left;
  padding-right: 10px;
}
.basicinfo>ul>li>div>div{
  position: relative;
}
.basicinfo>ul>li>div>div>ul{
  position: absolute;
  top: 33px;
  left: 0;
  z-index: 555;
  width: 100%;
  background-color: #fff;
  max-height: 200px;
  overflow: scroll;
  border: 1px solid #dcdde2;
}
.basicinfo>ul>li>div>div>ul>li{
  min-height: 26px;
  line-height: 26px;
  font-size: 14px;
  padding: 0 7px;
}
.basicinfo>ul>li>div>div>ul>li:hover{
  background-color: #2778E7;
  color: #fff;
  cursor: pointer;
}
.basicinfo>ul>.other>li>div{
  display: flex;
}
.basicinfo>ul>.other>li>div>label{
  min-width: 106px;
  padding:0 10px;
  text-align: left;
}
.basicinfo>ul>.other>li>p{
  display: flex;
}
.basicinfo>ul>.other>li>p>label{
  min-width: 106px;
  padding:0 10px;
  text-align: left;
  line-height: 42px;
}
.basicinfo>ul>li.longWidth{
  display: block;
}
.basicinfo>ul>li.longWidth>p{
  width: 100%;
  display: flex;
}
.basicinfo>ul>li.longWidth>p>label{
  min-width: 106px;
}
.basicinfo>ul>li.longWidth>p>label:not(.redsize){
  padding-left: 10px;
}
.basicinfo>ul>li.longWidth>div{
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.basicinfo>ul>li.longWidth>div>label{
  min-width: 106px;
}
.basicinfo>ul>li.longWidth>div>div{
  width: 78%;
  position: relative;
}
.basicinfo>ul>li.longWidth>div>div>ul{
  position: absolute;
  top: 35px;
  left: 0;
}
.right{
  float:right;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illTitle{
  background-color: #f7f7f7;
  border: 1px solid #dcdde2;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illTitle>span{
  padding-right: 5px;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illTitle>span:hover{
  color: #fe6e6e;
  cursor: pointer;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illMain{
  display: flex;
  justify-content: space-between;
  flex-flow: nowrap row;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illMain>p{
  width: 15%;
  font-weight: 600;
  margin-left: 10px;
  font-size: 14px;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illMain>ul{
  width: 85%;
  display: flex;
  justify-content: flex-start;
  padding: 5px;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illMain>ul>li{
  font-size: 14px;
  margin-right: 5px;
  line-height: 26px;
  height: 26px;
}
.basicinfo>ul>li.longWidth>div>div>ul>div.illMain>ul>li:hover{
  color: #fe6e6e;
  cursor: pointer;
}
.basicinfo>ul>li.longWidth>div>div>p>span{
  margin-right: 10px;
}
.basicinfo>ul>.other>li.longWidth>div>div>p>span>div{
  margin-left: 5px;
}
.basicinfo>ul>li.longWidth>div>div>div:not(:first-child){
  width: 100%;
}
.basicinfo>ul>li.longWidth>div>div>div:not(:first-child)>span{
  display: inline-block;
  margin-left: 15px;
}
.basicinfo>ul>li.longWidth>div>div>div:not(:first-child)>span>i{
  padding-left: 10px;
  color: #264ea5;
  cursor: pointer;
  background-color: #fff;
}
.basicinfo>ul>li.longWidth>div>div>div:not(:first-child)>span>.ivu-icon:hover{
  color: #ff4666;
}
li.longWidth .ivu-input-wrapper {
    display: inline-block;
    width: 100%;
    position: relative;
    vertical-align: middle;
    line-height: normal;
    margin-top: 5px;
}
li.longWidth>p>.ivu-input-wrapper{
  width: 78%;
}
.basicinfo>ul>li.longWidth.allergy{
  height: auto;
}
.basicinfo>ul>li.longWidth.allergy>div>label{
  padding-left: 10px;
}
.basicinfo>ul>div.other>li.longWidth.allergy>div>div>p{
  width: 100%;
}
.basicinfo>ul>li>p{
  width: 33%;
  display: flex;
  cursor: pointer;
}
.basicinfo>ul>li>p>label{
  min-width:106px;
}
.basicinfo>ul>li>p>label:not(.redsize){
  /* padding-left: 10px; */
  text-align: left;
  padding-right: 10px;
}
.basicinfo>ul>li:first-child>p>div:last-child{
  margin-left: 5px;
}
.assistant{
  border: 1px solid #c9c9c9;
}
.assistant>p{
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  border-bottom: 1px solid #c9c9c9;
}
.redsize::before {
    content: '*';
    color: #e2222e;
    display: inline-block;
    z-index: 1;
    position: absolute;
    left: 0;
    font-size: 14px;
}
.blank{
  position: relative;
  padding-left: 10px;
}
.blank::before{
  content: '';
  color: #aaa;
  display: inline-block;
  z-index: 1;
  position: absolute;
  left: 0;
  font-size: 14px;
  width: 5px;
  height: 100%;
}
.assistant>.itemTop{
  border-bottom: 1px solid #c9c9c9;
}
.assistant>.itemTop>ul>li{
  width: 35%;
  padding: 0 8px;
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  margin-top: 5px;
  text-align: center;
}
.assistant>.itemTop>ul{
  height: 40px;
}
.assistant>div.itemTop>ul{
  display: flex;
  justify-content: space-between;
}
.assistant>div.itemTop>ul>div{
  width: 60%;
  display: flex;
  justify-content: space-around;
}
.assistant>div.itemTop>ul>div>li{
  height: 34px;
  line-height: 34px;
  margin-top:7px;
  padding: 0 8px;
  width: 82px;
  cursor: pointer;
  text-align:center;
}
.assistant>.itemsBox{
  height: 400px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.assistant>.itemsBox>.leftItem{
  width: 28%;
  border: 1px solid #c9c9c9;
  overflow: scroll;
}
.assistant>.itemsBox>.leftItem>ul>li{
  text-align: left;
  padding: 5px 5px 5px 16px;
  cursor: pointer;
}
.assistant>.itemsBox>.leftItem>ul>li>p{
  padding-left:10px;
}
.assistant>.itemsBox>.leftItem>ul>li.left-active{
  color: #fff;
  background-color: #2778E7;
}
.assistant>.itemsBox>.itemMain{
  position: relative;
  width: 72%;
  border:1px solid #c9c9c9;
  overflow: scroll;
  margin-left: 10px;
}
.assistant>.itemsBox>.itemMain>ul>li{
  width: 100%;
  border-bottom: 1px solid #c9c9c9;
}
.assistant>.itemsBox>.itemMain>ul>div>li{
  width: 100%;
  border-bottom: 1px solid #c9c9c9;
}
.assistant>.itemsBox>.itemMain>ul>li:first-child{
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  height: 30px;
  line-height: 30px;
}
.assistant>.itemsBox>.itemMain>ul>li:first-child>span{
  width: 50%;
  text-align: center;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div:first-child{
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.assistant>.itemsBox>.itemMain>ul>.itemMainPro{
  width: 100%;
  position: absolute;
  top: 30px;
  left: 0;
  padding-bottom: 30px;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div{
  border-bottom:1px solid #c9c9c9;
  padding:5px;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div:last-child >div:first-child {
    border-bottom: 0;
    padding: 5px;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div{
  width: 100%;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div>p:nth-child(1){
  width: 60%;
  display: flex;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div>p:nth-child(1)>span:nth-child(1){
  display: inline-block;
  width: 25px;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div>p:nth-child(1)>span:nth-child(2){
  display: inline-block;
  width: 100%;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div:first-child>p:nth-child(2){
  width: 44%;
  display: flex;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div:first-child>p:nth-child(2)>span:first-child{
  width: 70%;
  text-align: center;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p:first-child{
  width: 100%;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p:first-child{
  padding-left: 15px;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p:not(:first-child){
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding-left: 25px;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #c9c9c9;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p.proTitle{
  height: 30px;
  line-height: 30px;
  color: #000;
  font-weight: 500;
  border-top: 1px solid #c9c9c9;
  border-bottom: 1px solid #c9c9c9;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p>span{
  display: inline-block;
  width: 20%;
  text-align: center;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p>span:first-child{
  /* display: table; */
  width: 20%;
  text-align: center;
  height: 100%;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>.subProject>p>span:first-child>img{
  width: auto;
  height: auto;
  max-width: 100%;
  /* display: table-cell; */
  vertical-align: middle;
  max-height: 100%;
}
/* 未选中选择按钮 */
.assistant>.itemsBox>.itemMain>ul>div>li>div>div>p:nth-child(2)>span.noSelButton{
  font-size: 12px;
  border: 1px solid #2778E7;
  background-color: #fff;
  color:  #2778E7;
  padding: 2px 10px;
  border-radius:10px; 
  height: 25px;
}
/*选中*/
.assistant>.itemsBox>.itemMain>ul>div>li>div>div>p:nth-child(2)>span.selButton{
  font-size: 12px;
  border: 1px solid #fff;
  background-color: #2778E7;
  color:  #fff;
  padding: 2px 10px;
  border-radius:10px; 
  height: 25px;
}
.assistant>.itemsBox>.itemMain>ul>div>li>div>div>p:nth-child(2)>span.btnHight{
  background-color: #2778E7;
  color: #fff;
}
.uploadBox{
  padding: 10px;
  display: flex;
  justify-content: space-around;
}
.uploadBox>.blankBox{
  width:106px;
}
.uploadBox>div{
  width:100%;
}
.uploadBox>div>div.imgBox{
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  border: 1px solid #c9c9c9;
  padding: 10px;
}
.uploadBox>div>div.imgBox>span{
  display: block;
  width: 100px;
  height: 100px;
  line-height: 100px;
  background-color: #F0EFEF;
  text-align: center;
  margin-right: 5px;
  position: relative;
}
.uploadBox>div>div.imgBox>div>div>span{
  display: block;
  width: 100px;
  height: 100px;
  line-height: 100px;
  background-color: #F0EFEF;
  text-align: center;
}
.uploadBox>div>div.imgBox>span>img{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.uploadBox>div>div.imgBox>.ivu-upload{
  margin-right: 5px;
}
.uploadBox>div>div.imgBox span>i{
  font-size: 28px;
  color: #C9C9C9;
}
.uploadBox>div>div.imgBox span>i.icon-close-b{
  font-size: 16px;
  position: absolute;
  top:0;
  right: 0;
  z-index: 10;
  height: 16px;
  line-height: 16px;
  color: #e2222e;
  cursor: pointer;
}
/* 已上传图片 */
.uploadBox>div>div.haveUpload{
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  border: 1px solid #c9c9c9;
  padding: 10px;
}
.uploadBox>div>div.haveUpload>span{
  display: table;
  width: 100px;
  height: 100px;
  background-color: #F0EFEF;
  text-align: center;
  
}
.uploadBox>div>div.haveUpload>span>img{
  width: auto;
  height: auto;
  max-width: 100%;
  display: table-cell;
  vertical-align: middle;
}
.uploadBox>div>div.haveUpload>span>i{
  font-size: 28px;
  color: #C9C9C9;
  display: table-cell;
  vertical-align: middle;
}
.uploadBox>div>p{
  margin-bottom: 5px;
}
.proItemBox{
  border-top:1px solid #c9c9c9;
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-around;
}
.proItemBox>p{
  width: 12%;
  text-align: right;
  /* padding-right: 10px; */
}
.proItemBox>div{
  width: 92%;
  border: 1px solid #c9c9c9;
}
.proItemBox>div>div>div.beforePro{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c9c9c9;
  height: 30px;
  line-height: 26px;
}
.proItemBox>div>div>div.beforePro>span:nth-child(1){
  width: 60%;
  padding-left: 10px;
}
.proItemBox>div>div>div.beforePro>span:nth-child(2){
  width: 30%;
}
.proItemBox>div>div>div.beforePro>span:nth-child(3){
  width: 10%;
}
.proItemBox>div>div>div.beforePro>span:nth-child(3)>i{
  color: #264ea5;
  margin-left: 10px;
  height: 100%;
  cursor: pointer;
}
.proItemBox>div>div>div.beforePro>span:nth-child(3)>i:hover{
  color: #ff4666;
}
.proItemBox>div>div>div.subProject>p{
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
  border-bottom:1px solid #c9c9c9 ;
  padding-left: 5%;
}
.proItemBox>div>div:last-child>div.subProject>p:last-child{
  border: 0;
}
.proItemBox>div>div>div.subProject>P>span{
  width:25%;
  text-align: center;
}
.proItemBox>div>div>div.subProject>P>span:first-child{
  text-align: left;
}
.feeBox{
  width: 100%;
}
.feeBox>p:first-child{
  /* width:100%; */
  display: flex;
  padding: 10px;
  justify-content: space-around; 
}
.feeBox>p>span:nth-child(1){
  width: 106px;
  text-align: right;
  line-height: 32px;
}
.feeBox>p>span:nth-child(2){
  width: 100%;
}
.feeBox>div{
  display:flex;
  justify-content: space-around; 
  padding: 10px;
}
.feeBox>div>div>span{
  display: inline-block;
  width: 80px;
  height: 30px;
}
.feeBox>div>span{
  width: 14%;
}
.feeBox>div>div{
  width: 82%;
}
.feeBox>div>div>span{
  padding: 4px;
}
.feeBox>div>div>span>.ivu-icon{
  color: #264ea5;
  margin-left: 10px;
  height: 100%;
  widows: 100%;
  cursor: pointer;
}
.feeBox>div>div>span>.ivu-icon:hover{
  color: #ff4666;
}
.dorAdviceBox>p{
  display: flex;
  justify-content: space-around;
  padding: 10px;
}
.dorAdviceBox>p>span:nth-child(1){
  width: 106px;
  text-align: left;
}
.dorAdviceBox>p>span:nth-child(2){
  width: 100%;
}
.leftBox .active-name{
  border: 1px solid #c9c9c9;
  border-bottom: 1px solid #fff;
}

.showProjectInfo{
  width: 100%;
  padding: 10px;
}
.showProjectInfo>div{
  width: 100%;
}
.showProjectInfo>div{
  width: 100%;
  border: 1px solid #c9c9c9;
  /* position: relative; */
}
.showProjectInfo>div>div>p{
  display: flex;
  justify-content: space-around;
  align-items:baseline;
  border-bottom: 1px solid #c9c9c9;
  padding: 5px;
}
.showProjectInfo>div>div>p>span:nth-child(1){
  width:50%;
  text-align: center;
}
.showProjectInfo>div>div>p>span:nth-child(2){
  width:28%;
  text-align: center;
}
.showProjectInfo>div>div>p>span:nth-child(3){
  width:20%;
}
.showProjectInfo>div>div>div>p{
  display: flex;
  justify-content: space-around;
  align-items:baseline;
  border-bottom: 1px solid #c9c9c9;
  padding: 5px;
}
.showProjectInfo>div>div>div>p>span:nth-child(1){
  width:50%;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}
.showProjectInfo>div>div>div>p>span:nth-child(2){
  width:28%;
  display: table-cell;
  text-align: center;
}
.showProjectInfo>div>div>div>p>span:nth-child(3){
  width:20%;
  display: table-cell;
  text-align: center;
}
.showProjectInfo>div>p>span{
  /* width: 20%; */
  display: table-cell;
  text-align: center;
}
.showProjectInfo>div>div>div>li{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  border-bottom: 1px solid #c9c9c9;
  padding: 5px;
}
.showProjectInfo>div>div>div>li:last-child{
  border-bottom:0; 
}
.showProjectInfo>div>div{
  /* position: absolute; */
  /* z-index: 10; */
  /* top: 100%; */
  background-color: #fff;
  width: 100%;
  border-top: 1px solid #c9c9c9;
  border-bottom: none;
  /* max-height: 250px; */
  overflow: scroll;
  /* margin-bottom: 20px; */
}
.showProjectInfo>div>.sum{
  display: flex;
  justify-content: space-around;
  text-align: right;
  padding:10px 20px 10px;
}
.showProjectInfo>div>.sum>span:first-child{
  color: #2778E7;
  cursor: pointer;
}
.clinic>.topBox>div.btnBox{
  padding: 10px;
}
.btnBox{
  display: flex;
  justify-content: center;
  padding: 10px;
}
.btnBox>.ivu-btn{
  margin-left:10px; 
}
.ivu-input-wrapper {
    display: inline-block;
    width: 100%;
    position: relative;
    vertical-align: middle;
    line-height: normal;
    margin-bottom: 5px;
}
.redsize{
  padding-left:10px;
}
.ivu-menu{
  width: 100% !important;
}
.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
    padding-left: 25px !important;
}
::-webkit-scrollbar {
    width: 14px;
    height: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/clinic/cliniclist/ClinicList.vue